import { Alert } from 'antd';
import React,{useState} from 'react';
import { useSelector} from 'react-redux';
import { withRouter } from "react-router-dom";
import Auth from '../../../shared/components/authentication';
import Connect from "../../../shared/redux/Connect.hoc";
import "./styles.scss";

const Home = ({ history }) => {
 //State Auth Redux
 const auth = useSelector((state) => state.auth.user)

 //hooks
 const [visibleLogin, setVisibleLogin] = useState(false);
 const [visibleSignin, setVisibleSignin] = useState(false);
 const [visibleForget, setVisibleForget] = useState(false);

 const onClickLogin = () => {
   setVisibleLogin(state => !state);
 }

 const onClickSingIn = () => {
   setVisibleSignin(state => !state);
 }

 const onClickForget = () => {
   setVisibleForget(state => !state);
   onClickLogin();


 }


return (
   <div className = 'home'>
 
      
       <div className = 'Home-Div'>
            <button className = "Home-Div-button" onClick = {()=> !auth ? onClickLogin() : history.push('/newmensajeria')}><div className= "Home-Div-div--button">Mensajeria</div></button>
            <button className = "Home-Div-button" onClick = {() => !auth ? onClickLogin() : history.push('/newservice')}><div className="Home-Div-div--button">Hogar / Oficina</div></button>
       </div>

        <Auth
        onClickForget={onClickForget}
        onClickLogin={onClickLogin}
        onClickSingIn={onClickSingIn}
        visibleForget={visibleForget}
        visibleLogin={visibleLogin}
        visibleSignin={visibleSignin}
        
        />
   </div>
    )



}


export default withRouter(Connect(Home));

